module.exports = __webpack_public_path__ + "static/img/details.531340f9.png";